import React from 'react';
import { BuManagementPage } from 'src/components/bu-management/BuManagementPage';

export const BuManagement: React.FC = () => <BuManagementPage />;
